import { render, staticRenderFns } from "./MobileSettings.vue?vue&type=template&id=55a61034&"
import script from "./MobileSettings.vue?vue&type=script&lang=js&"
export * from "./MobileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports